import { useTranslate } from '@/shared/lib'

const useValidate = () => {
  const { trs } = useTranslate()

  /**
   * Функция проверки на обязательность
   * @param value
   */
  const required = (value: string | number): any => {
    if (!value || value.toString().trim() === '') return trs('validate.required')

    return true
  }

  /**
   * Функция проверки на мин. длину
   * @param value
   * @param length
   */
  const minLength = (value: string, length: number): any => {
    if (!value || value.toString().trim().length < length)
      return trs('validate.min_length', { length })

    return true
  }

  /**
   * Функция проверки на номер
   * @param value
   */
  const number = (value: string | number): any => {
    if (isNaN(Number(value))) return trs('validate.is_number')

    return true
  }

  /**
   * Функция проверки на мин. число
   * @param value
   * @param min
   */
  const numberMin = (value: string | number, min: number = 0): any => {
    const number = Number(value)

    if (number < min) return trs('validate.min_number', { min })

    return true
  }

  /**
   * Функция проверки на макс. число
   * @param value
   * @param max
   */
  const numberMax = (value: string | number, max: number = 0): any => {
    const number = Number(value)

    if (number > max) return trs('validate.max_number', { max })

    return true
  }

  /**
   * Функция проверки на email
   * @param value
   */
  const email = (value: string): any => {
    if (!value || !value.toString().trim()) return true

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (!emailPattern.test(value)) return trs('validate.email')

    return true
  }

  /**
   * Функция проверки на номер телефона
   * @param value
   */
  const phone = (value: string): any => {
    if (!value || !value.toString().trim()) return true

    const phonePattern = /^\+?[1-9]\d{1,14}$/
    if (!phonePattern.test(value)) return trs('validate.phone')

    return true
  }

  /**
   * Функция проверки на соответствие полей
   * @param value
   * @param mathValue
   */
  const math = (value: string | number, mathValue: string | number): any => {
    if (!mathValue || !mathValue.toString().trim()) return true

    if (value != mathValue) return trs('validate.math')

    return true
  }

  /**
   * Функция проверки наличия адреса при 2 и более счетчиков
   * @param value
   * @param metersCounts
   */
  const isMeterAddress = (value: string, metersCounts: number): any => {
    if ((!value || !value.toString().trim()) && metersCounts > 1)
      return trs('validate.meter_address_required')

    return true
  }

  /**
   * Функция проверки на булев тип
   * @param value
   */
  const boolean = (value: any): any => {
    if (typeof value !== 'boolean') return trs('validate.boolean')

    return true
  }

  /**
   * Функция проверки файла на тип
   * @param files
   * @param fileTypes
   */
  const fileTypes = (files: File[], fileTypes: string[]): any => {
    if (
      files.some((item) => {
        if (!item) return false

        return !fileTypes.includes(item.type)
      })
    )
      return trs('validate.incorrect_format')

    return true
  }

  /**
   * Функция проверки файла на размер
   * @param files
   * @param photoLimit
   * @param fileLimit
   */
  const fileSize = (files: File[], photoLimit: number, fileLimit: number): any => {
    for (let i = 0; i < files.length; i++) {
      const item = files[i]

      if (item.type.startsWith('image/')) {
        if (item.size > photoLimit * 1000000)
          return trs('validate.photo_size_invalid', {
            size: photoLimit,
          })
      } else {
        if (item.size > photoLimit * 1000000)
          return trs('validate.file_size_invalid', {
            size: fileLimit,
          })
      }
    }

    return true
  }

  return {
    required,
    minLength,
    number,
    numberMin,
    numberMax,
    email,
    phone,
    math,
    isMeterAddress,
    boolean,
    fileSize,
    fileTypes,
  }
}

export default useValidate
